<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      :model="model"
      :required-date-value="dateRange"
      :use-action="false"
      :use-default-action="false"
      entity-name="inventoryConsume"
      icon="mdi-cards"
    >
      <template #footer="{}">
        <date-picker-input
          v-model="dateRange"
          card-class="pa-3"
          color="grey lighten-3"
        />
      </template>
    </ik-data-table>
  </div>
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import DatePickerInput from '@/views/AadenPages/dashboard/components/DatePickerInput.vue'
import { defaultDate } from '@/model/dataLayer/api/common/DateRepository'
import inventoryConsume from '@/model/dataLayer/api/storage/inventoryConsume'

export default {
  name: 'InventoryConsume',
  components: {
    DatePickerInput,
    IkDataTable
  },
  data () {
    return {
      dateRange: [defaultDate, defaultDate],
      model: inventoryConsume
    }
  }
}
</script>

<style scoped>

</style>
